import { render, staticRenderFns } from "./HeadReport.vue?vue&type=template&id=18e464ed&scoped=true&"
import script from "./HeadReport.vue?vue&type=script&lang=ts&"
export * from "./HeadReport.vue?vue&type=script&lang=ts&"
import style0 from "./HeadReport.vue?vue&type=style&index=0&id=18e464ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e464ed",
  null
  
)

export default component.exports